<template>
<div :class="['o-col', className, computedClass, computedOffset, autoCol]">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        className: {
            type: String
        },
        xs: {
            type: Number
        },
        sm: {
            type: Number
        },
        md: {
            type: Number
        },
        lg: {
            type: Number
        },
        xl: {
            type: Number
        },
        offsetXs: {
            type: Number
        },
        offsetSm: {
            type: Number
        },
        offsetMd: {
            type: Number
        },
        offsetLg: {
            type: Number
        },
        offsetXl: {
            type: Number
        },
        autoColXs: {
            type: Boolean
        },
        autoColSm: {
            type: Boolean
        },
        autoColMd: {
            type: Boolean
        },
        autoColLg: {
            type: Boolean
        },
        autoColXl: {
            type: Boolean
        }
    },
    computed: {
        computedClass() {
            var className = '';
            if (!this.xs && !this.autoColXs) {
                className = 'col-12';
            }
            if (this.xs && !this.autoColXs) {
                className += ' col-' + this.xs;
            }
            if (this.sm && !this.autoColSm) {
                className += ' col-sm-' + this.sm;
            }
            if (this.md && !this.autoColMd) {
                className += ' col-md-' + this.md;
            }
            if (this.lg && !this.autoColLg) {
                className += ' col-lg-' + this.lg;
            }
            if (this.xl && !this.autoColXl) {
                className += ' col-xl-' + this.xl;
            }
            return className;
        },
        computedOffset() {
            var className = '';
            if (this.offsetXs) {
                className += 'offset' + this.offsetXs;
            }
            if (this.offsetSm) {
                className += 'offset-sm-' + this.offsetSm;
            }
            if (this.offsetMd) {
                className += ' offset-md-' + this.offsetMd;
            }
            if (this.offsetLg) {
                className += ' offset-lg-' + this.offsetLg;
            }
            if (this.offsetXl) {
                className += ' offset-xl-' + this.offsetXl;
            }
            return className;
        },
        autoCol() {
            var className = '';
            if (this.autoColXs) {
                className += ' col';
            }
            if (this.autoColSm) {
                className += ' col-sm';
            }
            if (this.autoColMd) {
                className += ' col-md';
            }
            if (this.autoColLg) {
                className += ' col-lg';
            }
            if (this.autoColXl) {
                className += ' col-xl';
            }
            return className;
        }
    }
};
</script>
